import { PixelationLoaderProps } from "../NvsLoaders";

export const defaultPixelationLoaderProps: PixelationLoaderProps = {
  isLoading: false,
};
